import { render, staticRenderFns } from "./aiImgGenerate.vue?vue&type=template&id=2b83df3c&scoped=true"
import script from "./aiImgGenerate.vue?vue&type=script&lang=js"
export * from "./aiImgGenerate.vue?vue&type=script&lang=js"
import style0 from "./aiImgGenerate.vue?vue&type=style&index=0&id=2b83df3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b83df3c",
  null
  
)

export default component.exports